import { render, staticRenderFns } from "./message-branch.vue?vue&type=template&id=5fd33cca"
import script from "./message-branch.vue?vue&type=script&lang=ts"
export * from "./message-branch.vue?vue&type=script&lang=ts"
import style0 from "./message-branch.vue?vue&type=style&index=0&id=5fd33cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports